import React from 'react';

import Text from 'components/Text';
import TextWithGlyph from 'components/TextWithGlyph';

import './styles/MockSpreadsheet.scss';

type Props = {
  title: string;
  columnHeaders: string[];
  rows: Array<string[]>;
};

export default function MockSpreadsheet(props: Props) {
  return (
    <table className="MockSpreadsheet">
      <thead>
        <tr>
          <th className="MockSpreadsheet-title">
            <TextWithGlyph
              glyph="spreadsheet"
              glyphSize="medium"
              glyphColor="whiteout"
              color="whiteout"
              weight="semibold"
            >
              {props.title}
            </TextWithGlyph>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {props.columnHeaders.map((header) => (
            <th key={header} className="MockSpreadsheet-columnHeader">
              <Text weight="semibold">{header}</Text>
            </th>
          ))}
        </tr>
        {props.rows.map((row) => {
          return (
            <tr key={`${row[0]}-row`} className="MockSpreadsheet-row">
              {row.map((cell) => (
                <td key={cell} className="MockSpreadsheet-cell">
                  <Text color="graphite">{cell}</Text>
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
